import type { MessageDescriptor } from 'react-intl'
import { defineMessages } from 'react-intl'

export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS = 7_500
export const LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS = 100

const campaignLabelMessages = defineMessages({
  static: {
    id: 'LNZza58zIj',
    defaultMessage: 'Bonus points',
    description: 'Label for static bonus points campaign type',
  },
  double: {
    id: 'pY7FYVgtiL',
    defaultMessage: 'Double points',
    description: 'Label for double points campaign type',
  },
  doubleStatusCredits: {
    id: 'RX7uJ0Ws01',
    defaultMessage: 'Double status credits',
    description: 'Label for double status credits campaign type',
  },
  triple: {
    id: 'qmozooQB1c',
    defaultMessage: 'Triple points',
    description: 'Label for triple points campaign type',
  },
})

export const LOYALTY_BONUS_POINTS_CAMPAIGN_LABEL: Record<App.LoyaltyBonusPointsCampaignType, MessageDescriptor> = {
  static: campaignLabelMessages.static,
  double: campaignLabelMessages.double,
  double_status_credits: campaignLabelMessages.doubleStatusCredits,
  triple: campaignLabelMessages.triple,
}
